import { createAsyncThunk } from '@reduxjs/toolkit';

import { EnvironmentEnum } from '../../../../main/constants/environment.ts';
import { RootState } from '../../../../main/store/main.store.ts';
import { getAwsConfigUtil } from '../../../../main/utils/aws/aws-config.util.ts';
import { getReadingCrittersClientUtil } from '../../../../main/utils/clients/readingcritters.client.util.ts';
import { getUrlUtil } from '../../../../main/utils/url.util.ts';

import { ENVIRONMENT_QUERY_PARAM } from '../../../constants/environment-query-param.ts';
import { checkCustomEnvironmentRequest } from '../../../requests/check-custom-environment.request.ts';

import { ENVIRONMENT_SLICE_NAME } from '../environment.slice.types.ts';

import { getAndAssignEnvironmentOnInitThunk } from './get-and-assign-environment-on-init.thunk.ts';

export const checkOrSelectEnvironmentThunk = createAsyncThunk(
  `${ENVIRONMENT_SLICE_NAME}/checkOrSelectEnvironment`,
  async (_, thunkAPI) => {
    const setEnv = getUrlUtil().getQueryParams(window.location.href)[ENVIRONMENT_QUERY_PARAM];
    const { environment } = thunkAPI.getState() as RootState;

    if (setEnv?.[0]) {
      await thunkAPI.dispatch(getAndAssignEnvironmentOnInitThunk({ environmentName: setEnv[0] })).unwrap();
      return;
    }

    if (!environment.selectedEnvironment?.apiUrl) {
      await thunkAPI
        .dispatch(getAndAssignEnvironmentOnInitThunk({ environmentName: EnvironmentEnum.PRODUCTION }))
        .unwrap();
      return;
    }

    const isEnvironmentAvailable = await checkCustomEnvironmentRequest(
      environment.selectedEnvironment.apiUrl,
      environment.selectedEnvironment.apiKey
    );
    if (!isEnvironmentAvailable) {
      await thunkAPI
        .dispatch(getAndAssignEnvironmentOnInitThunk({ environmentName: EnvironmentEnum.PRODUCTION }))
        .unwrap();
      return;
    }

    getReadingCrittersClientUtil().initialize(environment.selectedEnvironment);
    getAwsConfigUtil().configureAws(environment.selectedEnvironment);
    return;
  }
);
